export const RESET = 'RESET';

export function reset() {
  return { type: RESET, payload: null };
};
